import { POSITION_FILL_REQUESTS_PATH } from 'domain/shared/positionFillRequest';
import type { HighlightUrlConfigItem } from 'framework/HighlightUrl';
import usePositionFillRequestsService from './usePositionFillRequestsService';
import {
  ID_PFR_HIGHLIGHT,
  POSITION_FILL_REQUEST_GET_WORK_INDICATOR,
} from 'domain/shared/positionFillRequest/constants';
import { useAuthorization } from 'framework/authorization';

const usePfrHighlightUrlService = (): HighlightUrlConfigItem => {
  const { getWorkIndicator } = usePositionFillRequestsService();
  const { isGranted } = useAuthorization();
  const getValue = async (): Promise<boolean> => {
    if (!isGranted(POSITION_FILL_REQUEST_GET_WORK_INDICATOR)) return false;

    const response = await getWorkIndicator();

    return response.hasWorkToDo;
  };

  return {
    id: ID_PFR_HIGHLIGHT,
    url: POSITION_FILL_REQUESTS_PATH,
    getValue,
  };
};

export default usePfrHighlightUrlService;
